import React from 'react'
import Navbar from '../components/Navbar'

const About = () => {
  return (
    <div>
      <Navbar/>
      <h1 className=' font-bold text-center text-xl my-4'>About Us</h1>
      <p className=' px-10 font-medium lg:px-40'>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Dolor ullam perferendis, fugit veritatis consequuntur repellat beatae a? Adipisci rerum consequuntur vero dolorum culpa. Quis nihil, totam iusto, cum at odit soluta ab harum adipisci nesciunt explicabo tempora mollitia, amet voluptatem reiciendis rerum sed vitae! Voluptatum in ea, iure, voluptate iste beatae earum similique ratione praesentium saepe non maiores rem repudiandae deserunt mollitia, consequuntur tempora. Modi cumque molestiae odit dolor expedita iste magni tempora perferendis esse ex tenetur facere ratione aliquid, non atque neque, praesentium ad! Iste explicabo nihil velit quo nobis sint fugit odio. Quos, nihil maxime cumque laudantium velit r sit amet consectetur, adipisicing elit. Dolor ullam </p>
    </div>
  )
}

export default About
